import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageComponent } from './components/page/page.component';
import { AuthGuard } from './guards/auth.guard';
import { DummyRefreshComponent } from './components/dummy-refresh/dummy-refresh.component';
import {ErrorComponent} from "./components/error/error.component";

const routes: Routes = [
  { path: '', redirectTo: 'nxi/welcome', pathMatch: 'full' },
  { path: 'login', redirectTo: 'nxi/welcome', pathMatch: 'full'},
  { path: 'nxi/login', redirectTo: 'nxi/welcome', pathMatch: 'full'},
  { path: 'login1', redirectTo: 'nxi/welcome', pathMatch: 'full'},
  { path: 'nxi/login1', redirectTo: 'nxi/welcome', pathMatch: 'full'},
  { path: 'nxi', redirectTo: 'nxi/welcome', pathMatch: 'full' },
  { path: 'nxi/dummy/refresh', component: DummyRefreshComponent },
  { path: 'nxi/page-not-found', component: ErrorComponent, pathMatch: 'full'},
  // below is for SSO landing page name mismatch
  { path: 'nxi/ssolandingredirect/account-profile', redirectTo: 'nxi/accounts/profile', pathMatch: 'full'},
  { path: 'nxi/ssolandingredirect/unrealizedgainloss', redirectTo: 'nxi/accounts/gainloss', pathMatch: 'full'},
  { path: 'nxi/ssolandingredirect/realizedgainloss', redirectTo: 'nxi/accounts/gainloss', pathMatch: 'full'},
  { path: 'nxi/ssolandingredirect/default-settings', redirectTo: 'nxi/settings/allsettings', pathMatch: 'full'},
  // end of: below is for SSO landing page name mismatch
  { path: '**', component: PageComponent, canActivate: [AuthGuard] }

];



@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
